import { BankAccount } from '@/types';
import { useMemo } from 'react';

export const useAccountSelectors = (accounts: BankAccount[]) => {
  return useMemo(() => ({
    getById: (id: string) =>
      accounts.find(a => a.id === id),
    
    getByBank: (bank: string) =>
      accounts.filter(a => a.bank === bank),
    
    getTotalBalance: () =>
      accounts.reduce((sum, a) => sum + a.balance, 0),
    
    getSortedByBalance: () =>
      [...accounts].sort((a, b) => b.balance - a.balance),
  }), [accounts]);
};
